let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("gIaSu")), load("3hNOW")]).then(() => parcelRequire('cG6ws'));